import { ColumnDatePicker } from './ColumnDatePicker';
import { ColumnGiftMessageEditor } from './ColumnGiftMessageEditor';
import { ColumnInput } from './ColumnInput';
import { ColumnMaskInput } from './ColumnMaskInput';
import { ColumnSelect } from './ColumnSelect';
import { ColumnSwitch } from './ColumnSwitch';
import { ColumnTagSelect } from './ColumnTagSelect';
import { ColumnTextEditor } from './ColumnTextEditor';
import {
  boolean,
  checkbox,
  date,
  datePicker,
  input,
  multiSelect,
  number,
  select,
  singleSelect,
  string,
  tags,
  tagSelect,
  textEditor,
  giftMessageEditor,
  mask
} from './types';

const defaultMappingByComponent = {
  [input]: ColumnInput,
  [checkbox]: ColumnSwitch,
  [datePicker]: ColumnDatePicker,
  [select]: ColumnSelect,
  [tagSelect]: ColumnTagSelect,
  [textEditor]: ColumnTextEditor,
  [giftMessageEditor]: ColumnGiftMessageEditor,
  [mask]: ColumnMaskInput
};

const mappingByType = {
  [string]: {
    component: input,
    props: {}
  },
  [number]: {
    component: input,
    props: {
      type: 'number'
    }
  },
  [boolean]: {
    component: checkbox,
    props: {}
  },
  [date]: {
    component: datePicker,
    props: {}
  },
  [singleSelect]: {
    component: select,
    props: {}
  },
  [multiSelect]: {
    component: select,
    props: {
      multi: true
    }
  },
  [tags]: {
    component: tagSelect,
    props: {}
  },
  [textEditor]: {
    component: textEditor,
    props: {}
  },
  [giftMessageEditor]: {
    component: giftMessageEditor,
    props: {}
  },
  [mask]: {
    component: mask,
    props: {}
  }
};

export { defaultMappingByComponent, mappingByType };
